import { setRetryData } from '@/util/retryStorage'

const refreshTypes = [
    "GENERATE_QR_ASYNC", "INVENTORY_API_ASYNC", "INVENTORY_APP_ASYNC",
    "INVENTORY_WEB_ASYNC", "REFRESH_CREDITS", "REFRESH_INVOICE", 
    "PACIOLAN_SCRAPE", "SEATGEEK_SCRAPE", "SEATGEEK_OFFICIAL_API",
]

const ACCOUNTS_LENGTH_THRESHOLD = 1000

const getQueryParams = (type, item) => {
    // Ensure _item and request_data exist
    if (!item._item) {
        console.error('getQueryParams: _item is missing', item)
        return {}
    }
    
    if (!item._item.request_data) {
        console.error('getQueryParams: request_data is missing', item._item)
        return {}
    }
    
    const request_data = item._item.request_data
    
    switch (type) {
        case "RESET_ACCOUNT_PASSWORD":
            if (!request_data.account_team || !request_data.account_user) {
                console.error('getQueryParams: Missing account data for RESET_ACCOUNT_PASSWORD', request_data)
                return {}
            }
            return {
                account: [request_data.account_team, request_data.account_user].join(":")
            }
        case "CREATE_BALLPARK_ACCOUNT":
            if (!request_data.account_user) {
                console.error('getQueryParams: Missing account data for CREATE_BALLPARK_ACCOUNT', request_data)
                return {}
            }
            return {
                account: [request_data.account_user, request_data.account_password || '', request_data.account_name || '', request_data.account_surname || ''].join(":")
            }
        case "REFRESH_INVOICE":
            if (!request_data.accounts || !Array.isArray(request_data.accounts)) {
                console.error('getQueryParams: Missing accounts array for REFRESH_INVOICE', request_data)
                return {}
            }
            return {
                accounts: request_data.accounts.map(acc => [acc.account_team, acc.account_user, acc.account_password].join(":")).join("\n"),
                enableFilter: request_data.filter != "",
                filter: request_data.filter || "",
            }
        case "WEB_PRINT_TICKET":
            if (!request_data.request_id) {
                console.error('getQueryParams: Missing request_id for WEB_PRINT_TICKET', request_data)
                return {}
            }
            return {
                history: request_data.request_id
            }
        case "SIDE_DMS":
            if (!request_data.links || !Array.isArray(request_data.links)) {
                console.error('getQueryParams: Missing links array for SIDE_DMS', request_data)
                return {}
            }
            return {
                url: request_data.links.join(";")
            }
    }

    if (refreshTypes.includes(type)) {
        console.log("Refresh types, return query", type)

        if (!request_data.accounts || !Array.isArray(request_data.accounts)) {
            console.error('getQueryParams: Missing accounts array for refresh type', type, request_data)
            return {}
        }

        let accounts = ""
        
        // SEATGEEK_SCRAPE uses account_user:account_password format
        if (type === "SEATGEEK_SCRAPE") {
            accounts = request_data.accounts.map(account => {
                if (!account.account_user || !account.account_password) {
                    console.warn('getQueryParams: Missing account_user or account_password for SEATGEEK_SCRAPE', account)
                    return null
                }
                return account.account_user + ':' + account.account_password
            }).filter(Boolean).join('\n')
        } else if (item._item.platform === 'seatgeek') {
            // SEATGEEK_OFFICIAL_API uses account_performer:account_token format
            accounts = request_data.accounts.map(account => {
                if (!account.account_performer || !account.account_token) {
                    console.warn('getQueryParams: Missing account_performer or account_token', account)
                    return null
                }
                return account.account_performer + ':' + account.account_token
            }).filter(Boolean).join('\n')
        } else {
            // Other platforms use account_team:account_user:account_password format
            accounts = request_data.accounts.map(acc => {
                if (!acc.account_team || !acc.account_user || !acc.account_password) {
                    console.warn('getQueryParams: Missing account data', acc)
                    return null
                }
                return [acc.account_team, acc.account_user, acc.account_password].join(":")
            }).filter(Boolean).join("\n")
        }

        const queryParams = {
            accounts: accounts,
            from_time: request_data.from_time,
            to_time: request_data.to_time,
            has_tbd: request_data.tbd_included || false,
        }

        // If accounts string is too long, store in sessionStorage
        if (accounts.length > ACCOUNTS_LENGTH_THRESHOLD) {
            console.log(`Accounts length (${accounts.length}) exceeds threshold (${ACCOUNTS_LENGTH_THRESHOLD}), using sessionStorage`)
            
            const retryKey = setRetryData(queryParams)
            
            // If sessionStorage fails, fallback to direct query params
            if (retryKey) {
                return { retryKey: retryKey }
            } else {
                console.warn('Failed to store in sessionStorage, falling back to direct query params')
                return queryParams
            }
        }

        return queryParams
    }

    console.log("No query params for this type", type)
    return {}
}

export default getQueryParams
